function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClosedSign = function SvgClosedSign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m4 6 3.1-3.7c1.5-1.8 4.3-1.8 5.8 0L16 6h4v12H0V6h4zm5.3-1.9c.4-.4 1.1-.4 1.5 0L12.3 6H7.7l1.6-1.9zm-.7 4.3c-.6-.5-1.6-.5-2.2 0-.5.6-.5 1.6 0 2.2L7.9 12l-1.4 1.4c-.6.6-.6 1.5 0 2.1.6.6 1.5.6 2.1 0l1.4-1.4 1.4 1.4c.6.6 1.5.6 2.1 0 .6-.6.6-1.5 0-2.1L12.1 12l1.4-1.4c.6-.6.6-1.5 0-2.1-.6-.6-1.5-.6-2.1 0L10 9.9 8.6 8.4z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgClosedSign;